import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Select from "react-select";
import * as departmentActions from "../../actions/departmentActions";
import * as loaderActions from "../../actions/loaderActions";

const DepartmentSelect = ({
  value: initialValue,
  isMulti = false,
  onChange,
  departments = [],
  actions,
  loading,
  label,
  placeholder,
  disabled
}) => {
  const fetchDepartments = useCallback(async () => {
    await actions.loadDepartments();
    actions.toggleLoader(false);
  }, [actions]);
  useEffect(() => {
    if (!departments.length) {
      actions.toggleLoader(true);
      fetchDepartments();
    }
  }, [actions, departments.length, fetchDepartments]);
  const options = departments
    .map((d) => ({
      label: d.description,
      value: d._id
    }))
    .sort((a, b) => {
      if (a.label > b.label) return 1;
      if (b.label > a.label) return -1;
      return 0;
    });

  const value =
    isMulti && Array.isArray(initialValue)
      ? options.filter((x) =>
          initialValue.find((i) => i === x.value || i.value === x.value)
        )
      : initialValue;

  return (
    <React.Fragment>
      {label ? (
        <label
          className={`control-label ${!label ? "hidden" : ""}`}
          htmlFor="department"
          style={{ textTransform: "uppercase" }}
        >
          {label}
        </label>
      ) : null}
      <Select
        id="department-select"
        name="department"
        className="react-select-container"
        classNamePrefix="react-select-container"
        fullwidth
        placeholder={placeholder}
        value={value}
        options={options}
        isClearable
        isLoading={loading}
        onChange={onChange}
        isMulti={isMulti}
        isDisabled={disabled}
      />
    </React.Fragment>
  );
};

DepartmentSelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  departments: PropTypes.array,
  actions: PropTypes.object,
  isMulti: PropTypes.bool,
  loading: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool
};

DepartmentSelect.defaultProps = {
  loading: false,
  placeholder: "Department",
  disabled: false
};

function mapStatesToProps(state) {
  return {
    departments: state.reducers.departments,
    loading: state.reducers.loader?.loading || false
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...departmentActions,
        ...loaderActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(DepartmentSelect);
